import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection, EditorialCallout } from '../../report/editorial';
import { resolveSectionCallout } from '../../../../lib/reportRendering/reportSectionCallouts';

export const DroughtResilienceSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.waterAnalysis?.droughtResilience;
  const callout = resolveSectionCallout(report, 'droughtResilience');
  const isQualitativeScreen = typeof text === 'string' && text.includes('qualitative basin exposure screen');
  return (
    <SectionShell label={label} hasData={!!text}>
      {text && (
        <EditorialSubsection
          theme={theme}
          label={isQualitativeScreen ? 'Qualitative Basin Drought Exposure Screen' : 'Drought Scenario Assessment'}
        >
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
      {callout && (
        <EditorialCallout theme={theme} tone={callout.tone} label={callout.label} style={{ marginTop: 8 }}>
          {callout.body}
        </EditorialCallout>
      )}
    </SectionShell>
  );
};
